import React, {useEffect,useState} from 'react';
import Logo from '../../assets/images/1_logo.png';
import '../../assets/style/font_wsweet.css';
import '../../assets/style/fonts.css';
import MainHeader from './MainHeader';
//import MainTiles from './common/MainTiles';
import MainFooter from './MainFooter';
import appstore_link from '../../assets/images/banner-appstore.svg';
import googleplay_link from '../../assets/images/banner-googleplay.svg';
import ConfirmDialog from '../../lib-ui/common/ConfirmDialog';
import UIString from '../../assets/content/UIString';
/*
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Util from '../../lib/Util';
*/


export default () => {

    const [lang, setLang] = useState('ko');
    //const navigate = useNavigate();
    const [confirmDialogText, setConfirmDialogText] = useState('');
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showPW, setShowPW] = useState(false);

    useEffect(() => {
        //  setLang(Util.get_url_lang());
        document.title = '1Day1Job';
    }, []);

    function showConfirmAlert(text) {
        setConfirmDialogText(text);
        setShowConfirmDialog(true);
    }



    return (
        <div style={{ width: '100%', height: '98vh', fontFamily: 'Roboto', fontSize: '13px', padding:'0x' }}>
            <table className={"base_table"} cellspacing={'0px'} cellpadding={'0px'}>
                <tr>
                    <td style={{height:'48px'}}>
                        <MainHeader />
                    </td>
                </tr>
                <tr>
                    <td style={{textAlign:'center',verticalAlign:'top',paddingTop:'110px'}}>


                    <img style={{ width: '30%', maxWidth: '400px', minWidth: '80px', marginTop: '110px', marginBottom: '60px' }} src={Logo} />
                    <div style={{height:'20px'}}>&nbsp;&nbsp;</div>
                        <span style={{ fontFamily: 'Sunflower', fontSize: '42px', fontWeight: 'normal' }}>1일1일</span><br />
                        <span style={{ fontFamily: 'Sunflower', fontSize: '13px', fontWeight: 'normal', fontFamily: 'Righteous'  }}>1DAY1JOB</span>
                        <div style={{height:'30px'}}>&nbsp;&nbsp;</div>
                       
                        <span style={{ color: '#222222', fontFamily: 'Sunflower', fontSize: '22px',lineHeight:'40px' }}>하루 한 가지, 단기 알바.</span>


                        <div style={{ textAlign: 'center', height: '90px', marginTop: '140px' }}>
                            <img src={appstore_link} style={{ height: '40px' }} />&nbsp;&nbsp;<img src={googleplay_link} style={{ height: '40px' }} />
                        </div>


                    </td>
                </tr>
                                {/*<tr>
                <td style={{ textAlign: 'center', verticalAlign: 'top', paddingTop:'80px',paddingBottom:'200px' }}>
                    <MainTiles />
                </td>
            </tr>*/}
                <tr>
                    <td style={{height:'200px',textAlign:'center'}}>
                    <MainFooter />
                    <ConfirmDialog show={showConfirmDialog} text={confirmDialogText} confirm_text={UIString[lang].CONFIRM} handle_close={() => { setShowConfirmDialog(false); }} />
                    </td>
                </tr>
            </table>

        </div>


    );

}